
  <div class="shipment-selector">
    <button mat-icon-button disableRipple="true"  [disabled]="disabled" (click)="openShipmentDetails()">
      <mat-icon>list_alt </mat-icon>
    </button>
   
  </div>